<template>
    <page-layout>
        <connect-network-failed :network="network" @go-back="$emit('go-to-source')" />

        <template slot="footer">
            <g-row type="flex" justify="space-around" :gutter="[8,8]">
                <g-column :span="24">
                    <g-typography tag="p" style="text-align: center">
                        Need Help?
                        <router-link :to="{name: 'v2.activation.brief.networks.faq'}">
                            <a>Read our FAQ's</a>
                        </router-link>
                    </g-typography>
                </g-column>
                <g-column style="text-align: center">
                    <powered-by-grin />
                </g-column>
            </g-row>
        </template>
    </page-layout>
</template>

<script>

    import PageLayout from '../../../../layouts/PageLayout';
    import ConnectNetworkFailed from '../../../networks/partials/ConnectNetworkFailed';

    export default {
        name:       'ActivationBriefConnectNetworkFailedView',
        components: {
            PageLayout,
            ConnectNetworkFailed,
        },
        computed: {
            network() {
                return this.$route.params.network;
            },
        },
    };
</script>
